var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-row gap-2" },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        {
          key: option.value,
          class:
            " \n      flex items-center cursor-pointer px-1 transition-all\n      " +
            _vm.colorHighlight("container", option, [
              "border",
              "color",
              "background"
            ]) +
            "\n    ",
          on: {
            click: function($event) {
              return _vm.input(option.value)
            }
          }
        },
        [
          _c(_vm.iconComponent, {
            tag: "component",
            class:
              _vm.iconComponent === "feather-icon" &&
              _vm.colorHighlight("icon", option, ["color"]),
            attrs: { icon: option.icon }
          }),
          _c(
            "span",
            { class: _vm.colorHighlight("label", option, ["color"]) },
            [_vm._v(" " + _vm._s(option.label ? option.label : "") + " ")]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }